// extracted by mini-css-extract-plugin
export var watermark = "WatermarkThree-module--watermark--bPI0A";
export var watermarkContainer = "WatermarkThree-module--watermarkContainer--sIAG+";